import { ComponentType, PropsWithChildren, PureComponent } from 'react';
import { logError } from '@bonanza-social/toolkit/logging';

import GenericErrorScreen from '../components/GenericErrorScreen/GenericErrorScreen';

type ErrorBoundaryProviderProps = {
  onError?: (data: unknown) => void;
  FallbackComponent?: ComponentType;
};

class ErrorBoundaryProvider extends PureComponent<
  PropsWithChildren<ErrorBoundaryProviderProps>,
  { hasError: boolean }
> {
  constructor(props: ErrorBoundaryProviderProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error: unknown, info: unknown) {
    const { onError } = this.props;

    logError('ErrorBoundary', { error, info });

    this.setState({ hasError: true });

    onError?.({ error, info });
  }

  render() {
    if (this.state.hasError) {
      const { FallbackComponent = GenericErrorScreen } = this.props;

      return <FallbackComponent />;
    }

    return this.props.children;
  }
}

export default ErrorBoundaryProvider;
